import React from 'react'

import {alpha, Box, Grid, Typography} from "@mui/material"
import {IconSeeker} from "@ui-seeker/core";
import { BIHeaders, BISubHeaders } from '../../@signals'
import { dsColorNew } from "@palette"


export default function pricesColumn(name, palette, idx) {

    return {
        name,
        setBodyCellProps: () => ({ sx:{ p: 0, verticalAlign: 'top', userSelect: 'none', cursor: 'default', borderRight: idx === BIHeaders.value.length - 1 ? 0 : `1px solid ${dsColorNew.grayBorder}` } }),
        render: value => <PriceCell value={value} />

    }
}


function PriceCell({ value }) {
    return <Box sx={{ p: 1, borderBottom: `1px solid ${dsColorNew.grayBorder}`, minHeight: 42}}>
        <Grid container spacing={1} sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
            {value?.map(({price, isCheapest, isMoreExpensive, evolutionChange, evolutionDiff, noresult}, idx) => {
                if (noresult || !price) return <Grid key={`${price}-${idx}`} item xs={12 / BISubHeaders.value?.length} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <Typography sx={{textAlign: 'center', width: '120px', fontSize: 13, color: dsColorNew.textSubtle, border: `1px dashed ${dsColorNew.grayBorder}`, borderRadius: '8px', py: 0.5}}>
                        N/A
                    </Typography>
                </Grid>
                return <Grid key={`${price}-${idx}`} item xs={12 / BISubHeaders.value?.length} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <Box sx={{
                        border: '1px solid',
                        borderColor: isCheapest ? alpha(dsColorNew.successText, 0.45) : isMoreExpensive ? alpha(dsColorNew.dangerRed, 0.45) : price === 'N/A' ? 'transparent' : dsColorNew.grayBorder,
                        backgroundColor: isCheapest ? alpha(dsColorNew.successText, 0.08) : isMoreExpensive ? alpha(dsColorNew.dangerRed, 0.08) : price === 'N/A' ? '' : dsColorNew.white,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', width: '120px'
                    }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Typography sx={{textAlign: 'center', fontWeight: 'bold'}}>
                                    {price}
                                </Typography>
                            </Grid>
                            {!!evolutionChange && evolutionDiff !== null && <Grid item xs={12} sx={{  height: 30 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, px: 2 }} >
                                    <IconSeeker
                                        icon={evolutionChange === "increase" ? "arrow-up" : evolutionChange === "decrease" ? "arrow-down" : "equals"}
                                        sx={{ color: evolutionChange === "increase" ? dsColorNew.successText : evolutionChange === "decrease" ? dsColorNew.dangerRed : "" }}
                                    />
                                    <Typography sx={{textAlign: 'center', fontSize: 11  }}>
                                        {evolutionDiff}%
                                    </Typography>
                                </Box>
                            </Grid>}
                        </Grid>
                    </Box>
                </Grid>
            })}
        </Grid>
    </Box>
}